import { ApprovalDialog } from '@components/Forms';
import { Button } from '@mui/material';
import React from 'react';

interface IUsersBatchButtonProps {
	onApprove: () => void;
	ids: string[];
	action: string;
}

const UsersBatchButton: React.FC<IUsersBatchButtonProps> = ({
	onApprove,
	ids,
	action
}) => {
	const [open, setOpen] = React.useState(false);

	const handleClick = React.useCallback(() => {
		setOpen(!open);
	}, [open, setOpen]);

	const handleCancelConfirmation = React.useCallback(() => {
		setOpen(false);
	}, [setOpen]);

	const handleApprovedConfirmation = React.useCallback(() => {
		onApprove();
		setOpen(false);
	}, [setOpen, onApprove]);

	return (
		<>
			<Button
				variant="outlined"
				size="small"
				data-testid={`users-${action}-button`}
				onClick={handleClick}
				sx={{
					mr: 2
				}}
			>
				{intl.tr(`users.table.action.${action}.button`)}
			</Button>
			{open && (
				<ApprovalDialog
					onApprove={handleApprovedConfirmation}
					onCancel={handleCancelConfirmation}
					title={intl.tr(`users.batch.${action}.dialog.title`)}
					question={intl.tr(`users.batch.${action}.dialog.question`, {
						number: ids.length
					})}
					approveText={intl.tr(`users.table.action.${action}.button`)}
					cancelText={intl.tr('button.cancel')}
				/>
			)}
		</>
	);
};

export default UsersBatchButton;
